import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount, ref, Ref } from 'vue';
import { useConfigStore } from '@/store';
import BannerList from '@/components/common/banner-list.vue';
import { ColumnLayout, ColumnType } from '@/types/banner-layout';

export default /*#__PURE__*/_defineComponent({
  __name: 'new-user-info',
  setup(__props) {

const { getFilteredLayout } = useConfigStore();

// banner 列表
const columnLayoutList: Ref<ColumnLayout[] | null> = ref(null);

onBeforeMount(async () => {
  const bannerConfig = await getFilteredLayout([ColumnType.d]);
  if (bannerConfig) {
    columnLayoutList.value = bannerConfig;
  }
});


return { __sfc: true,getFilteredLayout, columnLayoutList, BannerList }
}

})